export const INVEST_FUND_TAG_LIST = ['cies', 'finansol', 'greenfin', 'isr', 'novethic'] as const;
export type TInvestFundLabelTag = (typeof INVEST_FUND_TAG_LIST)[number];
